import React from "react";
import { IconAlertHexagon } from "@tabler/icons-react";

const FloatingAlert = ({ message, onClose, type = "danger", title = "Error" }) => {
  return (
    <div
      className="card"
      style={{
        position: "fixed",
        top: "30%",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1050,
        width: "90%",
        maxWidth: "400px",
        border: "2px solid rgba(214, 57, 57, 0.3)",
      }}
    >
      <div className="card-stamp">
        <div className="card-stamp-icon bg-red">
          <IconAlertHexagon size={52} />
        </div>
      </div>
      <div className="card-body">
        <h3 className="card-title">{title}</h3>
        <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>{message}</p>
      </div>
      <div className="card-footer text-end">
        <button className="btn btn-danger btn-pill" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default FloatingAlert;
